import { useState } from 'react';
import type { CapturedSignature } from '@/modules/agreements/subject/pages/signing-page/hooks/use-signing';

/**
 * The signature image and the signer's identity.
 *
 * Capturing an image does NOT sign. It produces an object reference that the final `sign`
 * call carries. The image is never presented as a certificate-backed digital signature.
 */
export function useSignatureIdentity() {
  const [signature, setSignature] = useState<CapturedSignature | null>(null);
  const [signerName, setSignerName] = useState('');
  const [signerTitle, setSignerTitle] = useState('');
  return { signature, setSignature, signerName, setSignerName, signerTitle, setSignerTitle };
}
